//缺3、应力孔
import makerjs from "makerjs";
// 矩形等去角 连线函数
function creatmyStressHoleGap(area, param) {
  console.log("是否调用此函数creatOneCorner（）");
  console.log("是否调用此函数creatOneCorner（）param=", param);
  var xa = param.xa, ya = param.ya, xb = param.xb, yb = param.yb, xc = param.xc, yc = param.yc, 
  xd = param.xd, yd = param.yd, xf = param.xf, yf = param.yf, 
  xg = param.xg, yg = param.yg, xh = param.xh, yh = param.yh, xi = param.xi, yi = param.yi,
  x = param.x0, r = param.r, d = param.d,w = param.w, h = param.h,dd = param.dd,h0 = param.h0,w0 = param.w0,
  glassH=param.glassH,glassW=param.glassW,cutLine=param.cutLine,cutFilletRadius=param.cutFilletRadius;
  if(glassW*1>glassH * 1){
      console.log("长边在X轴￥￥￥￥￥");
      if (area == "A") {
            var myStressHoleGap = {
                  paths: {
                    "LeftLine": new makerjs.paths.Line([xa, ya], [xa, ya-h0]),
                    "Arc": new makerjs.paths.Arc([xa, ya-h0], [xa+w, ya-h0],r,true,false),
                    "RightLine": new makerjs.paths.Line([xa+w, ya-h0], [xa+w, ya])
                  }
            };
            var myStressHoleGapWaterCut = {
                  paths: {
                    "EnLine": new makerjs.paths.Line([xa, ya+cutLine], [xa, ya]),
                    "LeftLine": new makerjs.paths.Line([xa, ya], [xa, ya-h0]),
                    "Arc": new makerjs.paths.Arc([xa, ya-h0], [xa+w, ya-h0],r,true,false),
                    "RightLine": new makerjs.paths.Line([xa+w, ya-h0], [xa+w, ya]),
                    "ExLine": new makerjs.paths.Line([xa+w, ya], [xa+w, ya+cutLine])
                  }
            };
          } else if (area == "B") {
            var myStressHoleGap = {
                  paths: {
                    "LeftLine": new makerjs.paths.Line([xb, yb], [xb, yb-h0]),
                    "Arc": new makerjs.paths.Arc([xb, yb-h0], [xb+w, yb-h0],r,true,false),
                    "RightLine": new makerjs.paths.Line([xb+w, yb-h0], [xb+w, yb])
                  }
            };
            var myStressHoleGapWaterCut = {
                  paths: {
                    "EnLine": new makerjs.paths.Line([xb, yb+cutLine], [xb, yb]),
                    "LeftLine": new makerjs.paths.Line([xb, yb], [xb, yb-h0]),
                    "Arc": new makerjs.paths.Arc([xb, yb-h0], [xb+w, yb-h0],r,true,false),
                    "RightLine": new makerjs.paths.Line([xb+w, yb-h0], [xb+w, yb]),
                    "ExLine": new makerjs.paths.Line([xb+w, yb], [xb+w, yb+cutLine])
                  }
            };
          } else if (area == "C") {
            var myStressHoleGap = {
                  paths: {
                        "LeftLine": new makerjs.paths.Line([xc-w, yc], [xc-w, yc-h0]),
                        "Arc": new makerjs.paths.Arc( [xc-w, yc-h0],[xc, yc-h0],r,true,false),
                        "RightLine": new makerjs.paths.Line([xc, yc-h0],[xc, yc])
                  }
            };
            var myStressHoleGapWaterCut = {
                  paths: {
                        "EnLine": new makerjs.paths.Line([xc-w, yc+cutLine], [xc-w, yc]),
                        "LeftLine": new makerjs.paths.Line([xc-w, yc], [xc-w, yc-h0]),
                        "Arc": new makerjs.paths.Arc( [xc-w, yc-h0],[xc, yc-h0],r,true,false),
                        "RightLine": new makerjs.paths.Line([xc, yc-h0],[xc, yc]),
                        "ExLine": new makerjs.paths.Line([xc, yc],[xc, yc+cutLine])
                  }
            };
          } else if (area == "G") {
            var myStressHoleGap = {
                  paths: {
                    "LeftLine": new makerjs.paths.Line([xg, yg], [xg, yg+h0]),
                    "Arc": new makerjs.paths.Arc([xg, yg+h0], [xg+w, yg+h0],r,true,true),
                    "RightLine": new makerjs.paths.Line([xg+w, yg+h0], [xg+w, yg])
                  }
            };
            var myStressHoleGapWaterCut = {
                  paths: {
                    "EnLine": new makerjs.paths.Line([xg, yg-cutLine], [xg, yg]),
                    "LeftLine": new makerjs.paths.Line([xg, yg], [xg, yg+h0]),
                    "Arc": new makerjs.paths.Arc([xg, yg+h0], [xg+w, yg+h0],r,true,true),
                    "RightLine": new makerjs.paths.Line([xg+w, yg+h0], [xg+w, yg]),
                    "ExLine": new makerjs.paths.Line([xg+w, yg], [xg+w, yg-cutLine])
                  }
            };
          } else if (area == "H") {
            var myStressHoleGap = {
                  paths: {
                    "LeftLine": new makerjs.paths.Line([xh, yh], [xh, yh+h0]),
                    "Arc": new makerjs.paths.Arc([xh, yh+h0], [xh+w, yh+h0],r,true,true),
                    "RightLine": new makerjs.paths.Line([xh+w, yh+h0], [xh+w, yh])
                  }
            };
            var myStressHoleGapWaterCut = {
                  paths: {
                    "EnLine": new makerjs.paths.Line([xh, yh-cutLine], [xh, yh]),
                    "LeftLine": new makerjs.paths.Line([xh, yh], [xh, yh+h0]),
                    "Arc": new makerjs.paths.Arc([xh, yh+h0], [xh+w, yh+h0],r,true,true),
                    "RightLine": new makerjs.paths.Line([xh+w, yh+h0], [xh+w, yh]),
                    "ExLine": new makerjs.paths.Line([xh+w, yh], [xh+w, yh-cutLine])
                  }
            };
          } else if (area == "I") {
            var myStressHoleGap = {
                  paths: {
                  "LeftLine": new makerjs.paths.Line([xi-w, yi+h0], [xi-w, yi]),
                 "Arc": new makerjs.paths.Arc([xi-w, yi+h0],[xi, yi+h0], r,true,true),
                 "RightLine": new makerjs.paths.Line([xi, yi], [xi, yi+h0])
                  }
            };
            var myStressHoleGapWaterCut = {
                  paths: {
                  "EnLine": new makerjs.paths.Line([xi-w, yi-cutLine], [xi-w, yi]),
                  "LeftLine": new makerjs.paths.Line([xi-w, yi+h0], [xi-w, yi]),
                 "Arc": new makerjs.paths.Arc([xi-w, yi+h0],[xi, yi+h0], r,true,true),
                 "RightLine": new makerjs.paths.Line([xi, yi], [xi, yi+h0]),
                 "ExLine": new makerjs.paths.Line([xi, yi], [xi, yi-cutLine])
                  }
            };
          }
}else{
     console.log("短边在X轴￥￥￥￥￥");
     if (area == "A") {
      var myStressHoleGap = {
            paths: {
              "LeftLine": new makerjs.paths.Line([xa, ya], [xa+h0, ya]),
              "Arc": new makerjs.paths.Arc([xa+h0, ya], [xa+h0, ya-w],r,true,true),
              "RightLine": new makerjs.paths.Line([xa+h0, ya-w], [xa, ya-w])
            }
      };
      var myStressHoleGapWaterCut = {
            paths: {
              "EnLine": new makerjs.paths.Line([xa-cutLine, ya], [xa, ya]),
              "LeftLine": new makerjs.paths.Line([xa, ya], [xa+h0, ya]),
              "Arc": new makerjs.paths.Arc([xa+h0, ya], [xa+h0, ya-w],r,true,true),
              "RightLine": new makerjs.paths.Line([xa+h0, ya-w], [xa, ya-w]),
              "ExLine": new makerjs.paths.Line([xa, ya-w], [xa-cutLine, ya-w])
            }
      };
    } else if (area == "D") {
      var myStressHoleGap = {
            paths: {
            "LeftLine": new makerjs.paths.Line([xd, yd+w/2], [xd+h0, yd+w/2]),
            "Arc": new makerjs.paths.Arc([xd+h0, yd+w/2], [xd+h0, yd-w/2],r,true,true),
            "RightLine": new makerjs.paths.Line([xd+h0, yd-w/2], [xd, yd-w/2])
            }
      };
      var myStressHoleGapWaterCut = {
            paths: {
            "EnLine": new makerjs.paths.Line([xd-cutLine, yd+w/2], [xd, yd+w/2]),
            "LeftLine": new makerjs.paths.Line([xd, yd+w/2], [xd+h0, yd+w/2]),
            "Arc": new makerjs.paths.Arc([xd+h0, yd+w/2], [xd+h0, yd-w/2],r,true,true),
            "RightLine": new makerjs.paths.Line([xd+h0, yd-w/2], [xd, yd-w/2]),
            "ExLine": new makerjs.paths.Line([xd, yd-w/2], [xd-cutLine, yd-w/2])
            }
      };
    } else if (area == "C") {
      var myStressHoleGap = {
            paths: {
                "LeftLine": new makerjs.paths.Line([xc, yc], [xc-h0, yc]),
                "Arc": new makerjs.paths.Arc([xc-h0, yc], [xc-h0, yc-w],r,true,false),
                "RightLine": new makerjs.paths.Line([xc-h0, yc-w], [xc, yc-w])
            }
      };
      var myStressHoleGapWaterCut = {
            paths: {
                "EnLine": new makerjs.paths.Line([xc+cutLine, yc], [xc, yc]),
                "LeftLine": new makerjs.paths.Line([xc, yc], [xc-h0, yc]),
                "Arc": new makerjs.paths.Arc([xc-h0, yc], [xc-h0, yc-w],r,true,false),
                "RightLine": new makerjs.paths.Line([xc-h0, yc-w], [xc, yc-w]),
                "ExLine": new makerjs.paths.Line([xc, yc-w], [xc+cutLine, yc-w])
            }
      };
    } else if (area == "G") {
      var myStressHoleGap = {
            paths: {
             "LeftLine": new makerjs.paths.Line([xg, yg], [xg+h0, yg]),
            "Arc": new makerjs.paths.Arc([xg+h0, yg], [xg+h0, yg+w],r,true,false),
            "RightLine": new makerjs.paths.Line([xg+h0, yg+w], [xg, yg+w])
            }
      };
      var myStressHoleGapWaterCut = {
            paths: {
             "EnLine": new makerjs.paths.Line([xg-cutLine, yg], [xg, yg]),
             "LeftLine": new makerjs.paths.Line([xg, yg], [xg+h0, yg]),
            "Arc": new makerjs.paths.Arc([xg+h0, yg], [xg+h0, yg+w],r,true,false),
            "RightLine": new makerjs.paths.Line([xg+h0, yg+w], [xg, yg+w]),
            "ExLine": new makerjs.paths.Line([xg, yg+w], [xg-cutLine, yg+w])
            }
      };
    } else if (area == "F") {
      var myStressHoleGap = {
            paths: {
                "LeftLine": new makerjs.paths.Line([xf, yf+w/2], [xf-h0, yf+w/2]),
                "Arc": new makerjs.paths.Arc([xf-h0, yf+w/2], [xf-h0, yf-w/2],r,true,false),
                "RightLine": new makerjs.paths.Line([xf-h0, yf-w/2], [xf, yf-w/2])
            }
      };
      var myStressHoleGapWaterCut = {
            paths: {
                "EnLine": new makerjs.paths.Line([xf+cutLine, yf+w/2], [xf, yf+w/2]),
                "LeftLine": new makerjs.paths.Line([xf, yf+w/2], [xf-h0, yf+w/2]),
                "Arc": new makerjs.paths.Arc([xf-h0, yf+w/2], [xf-h0, yf-w/2],r,true,false),
                "RightLine": new makerjs.paths.Line([xf-h0, yf-w/2], [xf, yf-w/2]),
                "ExLine": new makerjs.paths.Line([xf, yf-w/2], [xf+cutLine, yf-w/2])
            }
      };
    } else if (area == "I") {
      var myStressHoleGap = {
            paths: {
                "LeftLine": new makerjs.paths.Line([xi, yi], [xi-h0, yi]),
                "Arc": new makerjs.paths.Arc([xi-h0, yi], [xi-h0, yi+w],r,true,true),
                "RightLine": new makerjs.paths.Line([xi-h0, yi+w], [xi, yi+w])
            }
      };
      var myStressHoleGapWaterCut = {
            paths: {
                "EnLine": new makerjs.paths.Line([xi+cutLine, yi], [xi, yi]),
                "LeftLine": new makerjs.paths.Line([xi, yi], [xi-h0, yi]),
                "Arc": new makerjs.paths.Arc([xi-h0, yi], [xi-h0, yi+w],r,true,true),
                "RightLine": new makerjs.paths.Line([xi-h0, yi+w], [xi, yi+w]),
                "ExLine": new makerjs.paths.Line([xi, yi+w], [xi+cutLine, yi+w])
            }
      };
    }
}          
  
var fillet1 = makerjs.path.fillet(myStressHoleGapWaterCut.paths.LeftLine, myStressHoleGapWaterCut.paths.Arc, cutFilletRadius);
var fillet2 = makerjs.path.fillet(myStressHoleGapWaterCut.paths.Arc, myStressHoleGapWaterCut.paths.RightLine, cutFilletRadius);
myStressHoleGapWaterCut.paths.fillet1 = fillet1;
myStressHoleGapWaterCut.paths.fillet2 = fillet2;
  return [myStressHoleGap,myStressHoleGapWaterCut];
};
// 矩形等去角标记 连线函数      
function creatmyStressHoleGapMark(outParam, area, param, inputParam, fixedParam, OffsetParam, zoom) {
  console.log("是否调用此函数creatCornerMark()");
  console.log("是否调用此函数param", param);
  console.log("是否调用此函数outParam", outParam);
  console.log("是否调用此函数inputParam", inputParam);
  console.log("是否调用此函数OffsetParam", OffsetParam);
  var H=inputParam.H,D=inputParam.D,W=inputParam.W,X=inputParam.X,Y=inputParam.Y, myZoom = zoom * 1,
        xa = param.xa, ya = param.ya, xb = param.xb, yb = param.yb, xc = param.xc, yc = param.yc, 
         xd = param.xd, yd = param.yd, xf = param.xf, yf = param.yf,
        xg = param.xg, yg = param.yg, xh = param.xh, yh = param.yh, xi = param.xi, yi = param.yi,
        x = param.x0, r = param.r, d = param.d,w = param.w, h = param.h, 
        glassW = outParam.glassW, glassH = outParam.glassH,
       markShift = fixedParam.markShift*1, markShiftTwo = fixedParam.markShiftTwo*1,
        markShiftThree = fixedParam.markShiftThree*1, markShiftFour = fixedParam.markShiftFour*1, markHolesOneD = fixedParam.markHolesOneD*1,
        d = D*1*myZoom,
              w= W*1*myZoom,
              h= H*1*myZoom,
              r=d/2,
              dd=Math.sqrt(r*r-w/2*w/2).toFixed(),
              h0=h-dd,
              w0=(d-w)/2,
                x0 = X*1*myZoom,
                y0 = Y*1*myZoom;
     if(d!==0){
      var TxtD="∮"+D;
     }
     if(h!==0){
      var TxtH=H;
     }
     if(w!==0){
      var TxtW=W;
     }
     if(x0!==0){          
     var TxtX=X;
     }
     if(y0!==0){          
      var TxtY=Y;
     }
if(glassW*1>glassH * 1){
       console.log("长边在X轴￥￥￥￥￥");
       if (area == "A") {
            var myShgGapAMakerH = {
                  paths: {
                        "HALine0": new makerjs.paths.Line([xa+w+w0+markShiftTwo,ya], [xa+w+w0+markShiftTwo,ya-h]),
                        "HALine1": new makerjs.paths.Line([xa+w+w0,ya-h], [xa+w+w0+markShiftFour,ya-h]),
                  }
            };
            var myShgGapAMakerD = {
                  paths: {
                         "DALine0": new makerjs.paths.Line([xa-w0,ya-h], [xa-w0,ya-h-markShiftFour*2]),
                         "DALine1": new makerjs.paths.Line([xa-w0+d,ya-h], [xa-w0+d,ya-h-markShiftFour*2]),
                         "DALine2": new makerjs.paths.Line([xa-w0,ya-h-markShiftFour-markShiftTwo], [xa-w0+d, ya-h-markShiftFour-markShiftTwo]),
                  }
            };
            var myShgGapAMakerX = {
                  paths: {
                        "XALine0": new makerjs.paths.Line([xa - x0, ya + markShift], [xa, ya + markShift]),
                        "XALine1": new makerjs.paths.Line([xa - x0, ya], [xa - x0, ya + markShiftFour]),
                        "XALine2": new makerjs.paths.Line([xa, ya], [xa, ya + markShiftFour]),
                  }
            };
            var myShgGapAMakerW = {
                  paths: {
                        "WALine0": new makerjs.paths.Line([xa+w, ya], [xa+w, ya + markShiftFour]),
                        "WALine1": new makerjs.paths.Line([xa, ya+ markShift], [xa+w, ya + markShift]),
                  }
            };
              makerjs.model.addCaption(myShgGapAMakerH, TxtH, [xa+d+markShiftTwo,ya-h],[xa+d+markShiftTwo,ya]);//H文字标注
              makerjs.model.addCaption(myShgGapAMakerX, TxtX, [xa - x0, ya + markShiftTwo], [xa, ya + markShiftTwo]);//X文字标注
              makerjs.model.addCaption(myShgGapAMakerD, TxtD, [xa-w0,ya-h-markShiftFour*2], [xa-w0+d, ya-h-markShiftFour*2]);//D文字标注  
              makerjs.model.addCaption(myShgGapAMakerW, TxtW, [xa, ya+ markShiftFour], [xa+w, ya + markShiftFour]);//W文字标注  
              var markers = [myShgGapAMakerH,myShgGapAMakerX,myShgGapAMakerD,myShgGapAMakerW]
        } else if (area == "B") {
            var myShgGapBMakerH = {
                  paths: {
                        "HBLine0": new makerjs.paths.Line([xb+w+w0+markShiftTwo,yb], [xb+w+w0+markShiftTwo,yb-h]),
                        "HBLine1": new makerjs.paths.Line([xb+w+w0,yb-h], [xb+w+w0+markShiftFour,yb-h]),
                  }
            };
            var myShgGapBMakerD = {
                  paths: {
                         "DBLine0": new makerjs.paths.Line([xb-w0,yb-h], [xb-w0,yb-h-markShiftFour*2]),
                         "DBLine1": new makerjs.paths.Line([xb-w0+d,yb-h], [xb-w0+d,yb-h-markShiftFour*2]),
                         "DBLine2": new makerjs.paths.Line([xb-w0,yb-h-markShiftFour-markShiftTwo], [xb-w0+d, yb-h-markShiftFour-markShiftTwo]),
                  }
            };
            var myShgGapBMakerX = {
                  paths: {
                        // "XBLine0": new makerjs.paths.Line([xb - x0, yb + markShift], [xb, yb + markShift]),
                        // "XBLine1": new makerjs.paths.Line([xb - x0, yb], [xb - x0, yb + markShiftFour]),
                        // "XBLine2": new makerjs.paths.Line([xb, yb], [xb, yb + markShiftFour]),
                  }
            };
            var myShgGapBMakerW = {
                  paths: {
                        "WBLine0": new makerjs.paths.Line([xb, yb], [xb, yb + markShiftFour]),
                        "WBLine1": new makerjs.paths.Line([xb+w, yb], [xb+w, yb + markShiftFour]),
                        "WBLine2": new makerjs.paths.Line([xb, yb+ markShift], [xb+w, yb + markShift]),
                  }
            };
              makerjs.model.addCaption(myShgGapBMakerH, TxtH, [xb+d+markShiftTwo,yb-h],[xb+d+markShiftTwo,yb]);//H文字标注
              makerjs.model.addCaption(myShgGapBMakerX, TxtX, [xb - x0, yb + markShiftTwo], [xb, yb + markShiftTwo]);//X文字标注
              makerjs.model.addCaption(myShgGapBMakerD, TxtD, [xb-w0,yb-h-markShiftFour*2], [xb-w0+d, yb-h-markShiftFour*2]);//D文字标注  
              makerjs.model.addCaption(myShgGapBMakerW, TxtW, [xb, yb+ markShiftFour], [xb+w, yb + markShiftFour]);//W文字标注  
              var markers = [myShgGapBMakerH,myShgGapBMakerX,myShgGapBMakerD,myShgGapBMakerW]
        } else if (area == "C") {
            var myShgGapCMakerH = {
                  paths: {
                        "HCLine0": new makerjs.paths.Line([xc-w-w0-markShiftTwo,yc], [xc-w-w0-markShiftTwo,yc-h]),
                        "HCLine1": new makerjs.paths.Line([xc-w-w0,yc-h], [xc-w-w0-markShiftFour,yc-h]),
                  }
            };
            var myShgGapCMakerD = {
                  paths: {
                         "DCLine0": new makerjs.paths.Line([xc+w0,yc-h], [xc+w0,yc-h-markShiftFour*2]),
                         "DCLine1": new makerjs.paths.Line([xc+w0-d,yc-h], [xc+w0-d,yc-h-markShiftFour*2]),
                         "DCLine2": new makerjs.paths.Line([xc+w0,yc-h-markShiftFour-markShiftTwo], [xc+w0-d, yc-h-markShiftFour-markShiftTwo]),
                  }
            };
            var myShgGapCMakerX = {
                  paths: {
                        "XCLine0": new makerjs.paths.Line([xc+ x0, yc + markShift], [xc, yc + markShift]),
                        "XCLine1": new makerjs.paths.Line([xc + x0, yc], [xc + x0, yc + markShiftFour]),
                        "XCLine2": new makerjs.paths.Line([xc, yc], [xc, yc + markShiftFour]),
                  }
            };
            var myShgGapCMakerW = {
                  paths: {
                        "WCLine0": new makerjs.paths.Line([xc-w, yc], [xc-w, yc + markShiftFour]),
                        "WCLine1": new makerjs.paths.Line([xc, yc+ markShift], [xc-w, yc + markShift]),
                  }
            };
              makerjs.model.addCaption(myShgGapCMakerH, TxtH, [xc-d-markShiftTwo,yc-h],[xc-d-markShiftTwo,yc]);//H文字标注
              makerjs.model.addCaption(myShgGapCMakerX, TxtX, [xc, yc + markShiftFour], [xc + x0, yc + markShiftFour]);//X文字标注
              makerjs.model.addCaption(myShgGapCMakerD, TxtD, [xc+w0-d, yc-h-markShiftFour*2], [xc+w0,yc-h-markShiftFour*2]);//D文字标注  
              makerjs.model.addCaption(myShgGapCMakerW, TxtW, [xc-w, yc + markShiftFour], [xc, yc+ markShiftFour]);//W文字标注  
              var markers = [myShgGapCMakerH,myShgGapCMakerX,myShgGapCMakerD,myShgGapCMakerW]
        } else if (area == "G") {
            var myShgGapGMakerH = {
                  paths: {
                        "HGLine0": new makerjs.paths.Line([xg+w+w0+markShiftTwo,yg], [xg+w+w0+markShiftTwo,yg+h]),
                        "HGLine1": new makerjs.paths.Line([xg+w+w0,yg+h], [xg+w+w0+markShiftFour,yg+h]),
                  }
            };
            var myShgGapGMakerD = {
                  paths: {
                         "DGLine0": new makerjs.paths.Line([xg-w0,yg+h], [xg-w0,yg+h+markShiftFour*2]),
                         "DGLine1": new makerjs.paths.Line([xg-w0+d,yg+h], [xg-w0+d,yg+h+markShiftFour*2]),
                         "DGLine2": new makerjs.paths.Line([xg-w0,yg+h+markShiftFour+markShiftTwo], [xg-w0+d, yg+h+markShiftFour+markShiftTwo]),
                  }
            };
            var myShgGapGMakerX = {
                  paths: {
                        "XGLine0": new makerjs.paths.Line([xg - x0, yg - markShiftTwo], [xg, yg - markShiftTwo]),
                        "XGLine1": new makerjs.paths.Line([xg - x0, yg], [xg - x0, yg - markShiftFour]),
                        "XGLine2": new makerjs.paths.Line([xg, yg], [xg, yg - markShiftFour]),
                  }
            };
            var myShgGapGMakerW = {
                  paths: {
                        "WGLine0": new makerjs.paths.Line([xg+w, yg], [xg+w, yg - markShiftFour]),
                        "WGLine1": new makerjs.paths.Line([xg, yg-markShiftTwo], [xg+w, yg -markShiftTwo]),
                  }
            };
              makerjs.model.addCaption(myShgGapGMakerH, TxtH,[xg+d+markShiftTwo,yg], [xg+d+markShiftTwo,yg+h]);//H文字标注
              makerjs.model.addCaption(myShgGapGMakerX, TxtX, [xg - x0, yg - markShiftFour], [xg, yg - markShiftFour]);//X文字标注
              makerjs.model.addCaption(myShgGapGMakerD, TxtD, [xg-w0,yg+h+markShiftFour*2], [xg-w0+d, yg+h+markShiftFour*2]);//D文字标注  
              makerjs.model.addCaption(myShgGapGMakerW, TxtW, [xg, yg- markShiftFour], [xg+w, yg - markShiftFour]);//W文字标注  
              var markers = [myShgGapGMakerH,myShgGapGMakerX,myShgGapGMakerD,myShgGapGMakerW]
        } else if (area == "H") {
            var myShgGapHMakerH = {
                  paths: {
                        "HHLine0": new makerjs.paths.Line([xh+w+w0+markShiftTwo,yh], [xh+w+w0+markShiftTwo,yh+h]),
                        "HHLine1": new makerjs.paths.Line([xh+w+w0,yh+h], [xh+w+w0+markShiftFour,yh+h]),
                  }
            };
            var myShgGapHMakerD = {
                  paths: {
                         "DHLine0": new makerjs.paths.Line([xh-w0,yh+h], [xh-w0,yh+h+markShiftFour*2]),
                         "DHLine1": new makerjs.paths.Line([xh-w0+d,yh+h], [xh-w0+d,yh+h+markShiftFour*2]),
                         "DHLine2": new makerjs.paths.Line([xh-w0,yh+h+markShiftFour+markShiftTwo], [xh-w0+d, yh+h+markShiftFour+markShiftTwo]),
                  }
            };
            var myShgGapHMakerX = {
                  paths: {
                        // "XHLine0": new makerjs.paths.Line([xh - x0, yh - markShiftTwo], [xh, yh - markShiftTwo]),
                        // "XHLine1": new makerjs.paths.Line([xh - x0, yh], [xh - x0, yh - markShiftFour]),
                        // "XHLine2": new makerjs.paths.Line([xh, yh], [xh, yh - markShiftFour]),
                  }
            };
            var myShgGapHMakerW = {
                  paths: {
                        "WHLine0": new makerjs.paths.Line([xh, yh], [xh, yh - markShiftFour*2]),
                        "WHLine1": new makerjs.paths.Line([xh+w, yh], [xh+w, yh - markShiftFour*2]),
                        "WHLine2": new makerjs.paths.Line([xh, yh-markShiftFour-markShift], [xh+w, yh -markShiftFour-markShift]),
                  }
            };
              makerjs.model.addCaption(myShgGapHMakerH, TxtH,[xh+d+markShiftTwo,yh], [xh+d+markShiftTwo,yh+h]);//H文字标注
              makerjs.model.addCaption(myShgGapHMakerX, TxtX, [xh - x0, yh - markShiftFour], [xh, yh - markShiftFour]);//X文字标注
              makerjs.model.addCaption(myShgGapHMakerD, TxtD, [xh-w0,yh+h+markShiftFour*2], [xh-w0+d, yh+h+markShiftFour*2]);//D文字标注  
              makerjs.model.addCaption(myShgGapHMakerW, TxtW, [xh, yh- markShiftFour*2], [xh+w, yh - markShiftFour*2]);//W文字标注  
              var markers = [myShgGapHMakerH,myShgGapHMakerX,myShgGapHMakerD,myShgGapHMakerW]
        } else if (area == "I") {
            var myShgGapIMakerH = {
                  paths: {
                        "HILine0": new makerjs.paths.Line([xi-w-w0-markShiftTwo,yi], [xi-w-w0-markShiftTwo,yi+h]),
                        "HILine1": new makerjs.paths.Line([xi-w-w0,yi+h], [xi-w-w0-markShiftFour,yi+h]),
                  }
            };
            var myShgGapIMakerD = {
                  paths: {
                         "DILine0": new makerjs.paths.Line([xi+w0,yi+h], [xi+w0,yi+h+markShiftFour*2]),
                         "DILine1": new makerjs.paths.Line([xi+w0-d,yi+h], [xi+w0-d,yi+h+markShiftFour*2]),
                         "DILine2": new makerjs.paths.Line([xi+w0,yi+h+markShiftFour+markShiftTwo], [xi+w0-d, yi+h+markShiftFour+markShiftTwo]),
                  }
            };
            var myShgGapIMakerX = {
                  paths: {
                        "XILine0": new makerjs.paths.Line([xi+ x0, yi - markShiftTwo], [xi, yi - markShiftTwo]),
                        "XILine1": new makerjs.paths.Line([xi + x0, yi], [xi + x0, yi- markShiftFour]),
                        "XILine2": new makerjs.paths.Line([xi, yi], [xi, yi - markShiftFour]),
                  }
            };
            var myShgGapIMakerW = {
                  paths: {
                        "WILine0": new makerjs.paths.Line([xi-w, yi], [xi-w, yi - markShiftFour]),
                        "WILine1": new makerjs.paths.Line([xi, yi- markShiftTwo], [xi-w, yi -markShiftTwo]),
                  }
            };
              makerjs.model.addCaption(myShgGapIMakerH, TxtH,[xi-d-markShiftTwo,yi], [xi-d-markShiftTwo,yi+h]);//H文字标注
              makerjs.model.addCaption(myShgGapIMakerX, TxtX, [xi, yi- markShiftFour], [xi + x0, yi - markShiftFour]);//X文字标注
              makerjs.model.addCaption(myShgGapIMakerD, TxtD, [xi+w0-d, yi+h+markShiftFour*2], [xi+w0,yi+h+markShiftFour*2]);//D文字标注  
              makerjs.model.addCaption(myShgGapIMakerW, TxtW, [xi-w, yi - markShiftFour], [xi, yi- markShiftFour]);//W文字标注  
              var markers = [myShgGapIMakerH,myShgGapIMakerX,myShgGapIMakerD,myShgGapIMakerW]
        }
 }else{
      console.log("短边在X轴￥￥￥￥￥");
      if (area == "A") {
            var myShgGapAMakerH = {
                  paths: {
                        "HALine0": new makerjs.paths.Line([xa,ya+markShiftTwo], [xa+h,ya+markShiftTwo]),
                        "HALine1": new makerjs.paths.Line([xa+h,ya-w/2], [xa+h,ya-w/2+r+markShiftTwo]),
                  }
            };
            var myShgGapAMakerD = {
                  paths: {
                         "DALine0": new makerjs.paths.Line([xa+h,ya+w0], [xa+h+r+markShiftFour,ya+w0]),
                         "DALine1": new makerjs.paths.Line([xa+h,ya-w-w0], [xa+h+r+markShiftFour,ya-w-w0]),
                         "DALine2": new makerjs.paths.Line([xa+h+r+markShiftTwo,ya-w-w0], [xa+h+r+markShiftTwo,ya+w0]),
                  }
            };
            var myShgGapAMakerY = {
                  paths: {
                        "YALine0": new makerjs.paths.Line([xa - markShiftTwo, ya], [xa-markShiftTwo, ya + y0]),
                        "YALine1": new makerjs.paths.Line([xa - markShiftFour, ya+y0], [xa, ya + y0]),
                        "YALine2": new makerjs.paths.Line([xa - markShiftFour, ya], [xa, ya]),
                  }
            };
            var myShgGapAMakerW = {
                  paths: {
                        // "WALine0": new makerjs.paths.Line([xa+w, ya], [xa+w, ya + markShiftFour]),
                        "WALine1": new makerjs.paths.Line([xa+ markShift, ya-w], [xa+ markShift, ya]),
                  }
            };
              makerjs.model.addCaption(myShgGapAMakerH, TxtH, [xa,ya+markShiftThree], [xa+h,ya+markShiftThree]);//H文字标注
              makerjs.model.addCaption(myShgGapAMakerY, TxtY, [xa - markShiftThree, ya], [xa-markShiftThree, ya + y0]);//X文字标注
              makerjs.model.addCaption(myShgGapAMakerD, TxtD, [xa+h+r+markShiftFour,ya-w-w0], [xa+h+r+markShiftFour,ya+w0]);//D文字标注  
              makerjs.model.addCaption(myShgGapAMakerW, TxtW, [xa+ markShiftFour, ya-w], [xa+ markShiftFour, ya]);//W文字标注  
              var markers = [myShgGapAMakerH,myShgGapAMakerY,myShgGapAMakerD,myShgGapAMakerW]
        } else if (area == "D") {
            var myShgGapDMakerH = {
                  paths: {
                        "HDLine0": new makerjs.paths.Line([xd,yd+markShiftTwo+w/2], [xd+h,yd+markShiftTwo+w/2]),
                        "HDLine1": new makerjs.paths.Line([xd+h,yd], [xd+h,yd+r+markShiftTwo]),
                  }
            };
            var myShgGapDMakerD = {
                  paths: {
                         "DDLine0": new makerjs.paths.Line([xd+h,yd+w0+w/2], [xd+h+r+markShiftFour,yd+w0+w/2]),
                         "DDLine1": new makerjs.paths.Line([xd+h,yd-w/2-w0], [xd+h+r+markShiftFour,yd-w/2-w0]),
                         "DDLine2": new makerjs.paths.Line([xd+h+r+markShiftTwo,yd-w/2-w0], [xd+h+r+markShiftTwo,yd+w0+w/2]),
                  }
            };
            var myShgGapDMakerY = {
                  paths: {
                        // "YDLine0": new makerjs.paths.Line([xd - markShiftTwo, yd+w/2], [xd-markShiftTwo, yd + y0+w/2]),
                        // "YDLine1": new makerjs.paths.Line([xd - markShiftFour, yd+y0+w/2], [xd, yd + y0+w/2]),
                        // "YDLine2": new makerjs.paths.Line([xd - markShiftFour, yd+w/2], [xd, yd+w/2]),
                  }
            };
            var myShgGapDMakerW = {
                  paths: {
                        // "WDLine0": new makerjs.paths.Line([xd+w, yd], [xd+w, yd + markShiftFour]),
                        "WDLine1": new makerjs.paths.Line([xd+ markShift, yd-w/2], [xd+ markShift, yd+w/2]),
                  }
            };
              makerjs.model.addCaption(myShgGapDMakerH, TxtH, [xd,yd+markShiftThree+w/2], [xd+h,yd+markShiftThree+w/2]);//H文字标注
              makerjs.model.addCaption(myShgGapDMakerY, TxtY, [xd - markShiftThree, yd+w/2], [xd-markShiftThree, yd + y0+w/2]);//X文字标注
              makerjs.model.addCaption(myShgGapDMakerD, TxtD, [xd+h+r+markShiftFour,yd-w/2-w0], [xd+h+r+markShiftFour,yd+w0+w/2]);//D文字标注  
              makerjs.model.addCaption(myShgGapDMakerW, TxtW, [xd+ markShiftFour, yd-w/2], [xd+ markShiftFour, yd+w/2]);//W文字标注  
              var markers = [myShgGapDMakerH,myShgGapDMakerY,myShgGapDMakerD,myShgGapDMakerW]
        } else if (area == "C") {
            var myShgGapCMakerH = {
                  paths: {
                        "HCLine0": new makerjs.paths.Line([xc,yc+markShiftTwo], [xc-h,yc+markShiftTwo]),
                        "HCLine1": new makerjs.paths.Line([xc-h,yc-w/2], [xc-h,yc-w/2+r+markShiftTwo]),
                  }
            };
            var myShgGapCMakerD = {
                  paths: {
                         "DCLine0": new makerjs.paths.Line([xc-h,yc+w0], [xc-h-r-markShiftFour,yc+w0]),
                         "DCLine1": new makerjs.paths.Line([xc-h,yc-w-w0], [xc-h-r-markShiftFour,yc-w-w0]),
                         "DCLine2": new makerjs.paths.Line([xc-h-r-markShiftTwo,yc-w-w0], [xc-h-r-markShiftTwo,yc+w0]),
                  }
            };
            var myShgGapCMakerY = {
                  paths: {
                        "YCLine0": new makerjs.paths.Line([xc + markShift, yc], [xc+markShift, yc + y0]),
                        "YCLine1": new makerjs.paths.Line([xc + markShiftFour, yc+y0], [xc, yc + y0]),
                        "YCLine2": new makerjs.paths.Line([xc + markShiftFour, yc], [xc, yc]),
                  }
            };
            var myShgGapCMakerW = {
                  paths: {
                        // "WCLine0": new makerjs.paths.Line([xc+w, yc], [xc+w, yc + markShiftFour]),
                        "WCLine1": new makerjs.paths.Line([xc- markShift, yc-w], [xc- markShift, yc]),
                  }
            };
              makerjs.model.addCaption(myShgGapCMakerH, TxtH, [xc-h,yc+markShiftThree], [xc,yc+markShiftThree]);//H文字标注
              makerjs.model.addCaption(myShgGapCMakerY, TxtY, [xc + markShiftThree, yc], [xc+markShiftThree, yc + y0]);//X文字标注
              makerjs.model.addCaption(myShgGapCMakerD, TxtD, [xc-h-r-markShiftFour,yc-w-w0], [xc-h-r-markShiftFour,yc+w0]);//D文字标注  
              makerjs.model.addCaption(myShgGapCMakerW, TxtW, [xc- markShiftFour, yc-w], [xc- markShiftFour, yc]);//W文字标注  
              var markers = [myShgGapCMakerH,myShgGapCMakerY,myShgGapCMakerD,myShgGapCMakerW]
        } else if (area == "G") {
            var myShgGapGMakerH = {
                  paths: {
                        "HGLine0": new makerjs.paths.Line([xg,yg-markShiftTwo], [xg+h,yg-markShiftTwo]),
                        "HGLine1": new makerjs.paths.Line([xg+h,yg+w/2], [xg+h,yg+w/2-r-markShiftTwo]),
                  }
            };
            var myShgGapGMakerD = {
                  paths: {
                         "DGLine0": new makerjs.paths.Line([xg+h,yg-w0], [xg+h+r+markShiftFour,yg-w0]),
                         "DGLine1": new makerjs.paths.Line([xg+h,yg+w+w0], [xg+h+r+markShiftFour,yg+w+w0]),
                         "DGLine2": new makerjs.paths.Line([xg+h+r+markShiftTwo,yg+w+w0], [xg+h+r+markShiftTwo,yg-w0]),
                  }
            };
            var myShgGapGMakerY = {
                  paths: {
                        "YGLine0": new makerjs.paths.Line([xg - markShiftTwo, yg], [xg-markShiftTwo, yg - y0]),
                        "YGLine1": new makerjs.paths.Line([xg - markShiftFour, yg-y0], [xg, yg - y0]),
                        "YGLine2": new makerjs.paths.Line([xg - markShiftFour, yg], [xg, yg]),
                  }
            };
            var myShgGapGMakerW = {
                  paths: {
                        // "WGLine0": new makerjs.paths.Line([xg+w, yg], [xg+w, yg + markShiftFour]),
                        "WGLine1": new makerjs.paths.Line([xg+ markShift, yg+w], [xg+ markShift, yg]),
                  }
            };
              makerjs.model.addCaption(myShgGapGMakerH, TxtH, [xg,yg-markShiftFour], [xg+h,yg-markShiftFour]);//H文字标注
              makerjs.model.addCaption(myShgGapGMakerY, TxtY, [xg - markShiftThree, yg - y0], [xg-markShiftThree, yg]);//X文字标注
              makerjs.model.addCaption(myShgGapGMakerD, TxtD, [xg+h+r+markShiftFour,yg-w0], [xg+h+r+markShiftFour,yg+w+w0]);//D文字标注  
              makerjs.model.addCaption(myShgGapGMakerW, TxtW, [xg+ markShiftFour, yg], [xg+ markShiftFour, yg+w]);//W文字标注  
              var markers = [myShgGapGMakerH,myShgGapGMakerY,myShgGapGMakerD,myShgGapGMakerW]
        } else if (area == "F") {
            var myShgGapFMakerH = {
                  paths: {
                        "HFLine0": new makerjs.paths.Line([xf,yf+markShiftTwo+w/2], [xf-h,yf+markShiftTwo+w/2]),
                        "HFLine1": new makerjs.paths.Line([xf-h,yf], [xf-h,yf+r+markShiftTwo]),
                  }
            };
            var myShgGapFMakerD = {
                  paths: {
                         "DFLine0": new makerjs.paths.Line([xf-h,yf+w0+w/2], [xf-h-r-markShiftFour,yf+w0+w/2]),
                         "DFLine1": new makerjs.paths.Line([xf-h,yf-w/2-w0], [xf-h-r-markShiftFour,yf-w/2-w0]),
                         "DFLine2": new makerjs.paths.Line([xf-h-r-markShiftTwo,yf-w/2-w0], [xf-h-r-markShiftTwo,yf+w0+w/2]),
                  }
            };
            var myShgGapFMakerY = {
                  paths: {
                        // "YFLine0": new makerjs.paths.Line([xf + markShiftTwo, yf+w/2], [xf+markShiftTwo, yf + y0+w/2]),
                        // "YFLine1": new makerjs.paths.Line([xf + markShiftFour, yf+y0+w/2], [xf, yf + y0+w/2]),
                        // "YFLine2": new makerjs.paths.Line([xf + markShiftFour, yf+w/2], [xf, yf+w/2]),
                  }
            };
            var myShgGapFMakerW = {
                  paths: {
                        // "WFLine0": new makerjs.paths.Line([xf+w, yf], [xf+w, yf + markShiftFour]),
                        "WFLine1": new makerjs.paths.Line([xf- markShift, yf-w/2], [xf- markShift, yf+w/2]),
                  }
            };
              makerjs.model.addCaption(myShgGapFMakerH, TxtH, [xf-h,yf+markShiftThree+w/2], [xf,yf+markShiftThree+w/2]);//H文字标注
              makerjs.model.addCaption(myShgGapFMakerY, TxtY, [xf + markShiftThree, yf+w/2], [xf+markShiftThree, yf + y0+w/2]);//X文字标注
              makerjs.model.addCaption(myShgGapFMakerD, TxtD, [xf-h-r-markShiftFour,yf-w/2-w0], [xf-h-r-markShiftFour,yf+w0+w/2]);//D文字标注  
              makerjs.model.addCaption(myShgGapFMakerW, TxtW, [xf- markShiftFour, yf-w/2], [xf- markShiftFour, yf+w/2]);//W文字标注  
              var markers = [myShgGapFMakerH,myShgGapFMakerY,myShgGapFMakerD,myShgGapFMakerW]
        } else if (area == "I") {
            var myShgGapIMakerH = {
                  paths: {
                        "HILine0": new makerjs.paths.Line([xi,yi-markShiftTwo], [xi-h,yi-markShiftTwo]),
                        "HILine1": new makerjs.paths.Line([xi-h,yi+w/2], [xi-h,yi+w/2-r-markShiftTwo]),
                  }
            };
            var myShgGapIMakerD = {
                  paths: {
                         "DILine0": new makerjs.paths.Line([xi-h,yi-w0], [xi-h-r-markShiftFour,yi-w0]),
                         "DILine1": new makerjs.paths.Line([xi-h,yi+w+w0], [xi-h-r-markShiftFour,yi+w+w0]),
                         "DILine2": new makerjs.paths.Line([xi-h-r-markShiftTwo,yi+w+w0], [xi-h-r-markShiftTwo,yi-w0]),
                  }
            };
            var myShgGapIMakerY = {
                  paths: {
                        "YILine0": new makerjs.paths.Line([xi + markShift, yi], [xi+markShift, yi - y0]),
                        "YILine1": new makerjs.paths.Line([xi + markShiftFour, yi-y0], [xi, yi - y0]),
                        "YILine2": new makerjs.paths.Line([xi + markShiftFour, yi], [xi, yi]),
                  }
            };
            var myShgGapIMakerW = {
                  paths: {
                        // "WILine0": new makerjs.paths.Line([xi+w, yi], [xi+w, yi + markShiftFour]),
                        "WILine1": new makerjs.paths.Line([xi- markShift, yi+w], [xi- markShift, yi]),
                  }
            };
              makerjs.model.addCaption(myShgGapIMakerH, TxtH, [xi-h,yi-markShiftFour], [xi,yi-markShiftFour]);//H文字标注
              makerjs.model.addCaption(myShgGapIMakerY, TxtY, [xi + markShiftThree, yi- y0], [xi+markShiftThree, yi]);//X文字标注
              makerjs.model.addCaption(myShgGapIMakerD, TxtD, [xi-h-r-markShiftFour,yi-w0], [xi-h-r-markShiftFour,yi+w+w0]);//D文字标注  
              makerjs.model.addCaption(myShgGapIMakerW, TxtW, [xi- markShiftFour, yi], [xi- markShiftFour, yi+w]);//W文字标注  
              var markers = [myShgGapIMakerH,myShgGapIMakerY,myShgGapIMakerD,myShgGapIMakerW]
        }
 }
 
  console.log("markers||||||||||||||||||=", markers)
  return markers;
};
// inputParam,model,myHolesNum,outParam,fixedParam
// (D,X,Y,area,plate,markers,myHolesNum,glassW,glassH,markShift,markShiftTwo,markShiftThree,markShiftFour,markHolesOneD)
function StressHoleGap(inputParam, model, myHolesNum, outParam, fixedParam, zoom, θCut, rCut,cutLine,cutFilletRadius){
  var frame = outParam.shapeName;
  console.log("outParam==", outParam)
  console.log("model==", model)
  console.log("inputParam==", inputParam)
  console.log("outParam.shapeName==////////", outParam.shapeName)
  if (typeof (frame) == "undefined") {
        var H=inputParam.H,D=inputParam.D,W=inputParam.W,X=inputParam.X,Y=inputParam.Y,area=inputParam.area,myZoom=zoom*1, myθCut = θCut, myrCut = rCut,
        plate = model.plate, cutPlate = model.cutPlate, markers = model.markers, frame = "Rectangle",
              glassW = outParam.glassW, glassH = outParam.glassH,cutLine=cutLine*1,cutFilletRadius=cutFilletRadius*1,
              markShift = fixedParam.markShift, markShiftTwo = fixedParam.markShiftTwo,
              markShiftThree = fixedParam.markShiftThree, markShiftFour = fixedParam.markShiftFour, markHolesOneD = fixedParam.markHolesOneD,
              d = D*1*myZoom,
              w= W*1*myZoom,
              h= H*1*myZoom,
              r=d/2,
              dd=Math.sqrt(r*r-w/2*w/2).toFixed(),
              h0=h-dd,
              w0=(d-w)/2,
                x0 = X*1*myZoom,
                y0 = Y*1*myZoom;
                console.log("dd=88888=typeof",typeof(dd));
                console.log("dd=88888=",dd);
                if(plate.models===undefined||plate.models===""){
                  console.log("1111111111111111");
                  plate.models={};
                          }        
                          if(cutPlate.models===undefined||cutPlate.models===""){
                              console.log("22222222222");
                              //cutPlate.models={};
                              cutPlate.models={};
                          }
                          if(markers.models===undefined||markers.models===""){            
                              console.log("333333333333");
                              markers.models={};
                          }
     if(d!==0){
      var TxtD="∮"+D;
     }
     if(h!==0){
      var TxtH=H;
     }
     if(w!==0){
      var TxtW=W;
     }
     if(x0!==0){          
     var TxtX=X;
     }
     if(y0!==0){          
      var TxtY=Y;
     }
  } else {
        var H=inputParam.H,D=inputParam.D,W=inputParam.W,X=inputParam.X,Y=inputParam.Y,area=inputParam.area,myZoom=zoom*1, myθCut = θCut, myrCut = rCut,
        plate = model.plate, cutPlate = model.cutPlate, markers = model.markers, frame = outParam.shapeName,
              glassW = outParam.glassW, glassH = outParam.glassH,cutLine=cutLine*1,cutFilletRadius=cutFilletRadius*1,
              markShift = fixedParam.markShift, markShiftTwo = fixedParam.markShiftTwo,
              markShiftThree = fixedParam.markShiftThree, markShiftFour = fixedParam.markShiftFour, markHolesOneD = fixedParam.markHolesOneD,
              d = D*1*myZoom,
              w= W*1*myZoom,
              h= H*1*myZoom,
              r=d/2,
              dd=Math.sqrt(r*r-w/2*w/2).toFixed(),
              h0=h-dd,
              w0=(d-w)/2,
                x0 = X*1*myZoom,
                y0 = Y*1*myZoom;
                if(plate.models===undefined||plate.models===""){
                  console.log("1111111111111111");
                  plate.models={};
                          }        
                          if(cutPlate.models===undefined||cutPlate.models===""){
                              console.log("22222222222");
                              //cutPlate.models={};
                              cutPlate.models={};
                          }
                          if(markers.models===undefined||markers.models===""){            
                              console.log("333333333333");
                              markers.models={};
                          }
                if(d!==0){
                 var TxtD="∮"+D;
                }
                if(h!==0){
                 var TxtH=H;
                }
                if(w!==0){
                 var TxtW=W;
                }
                if(x0!==0){          
                var TxtX=X;
                }
                if(y0!==0){          
                 var TxtY=Y;
                }
  }
  if (frame == "Rectangle") {
        console.log("frame==undefined||||*****")
        //在A区域 计算孔的位置       
        var xa = x0, ya = glassH * 1 - y0,
              //B区域//只有Y标注没有X标注 
              xb = glassW * 1 / 2, yb = glassH * 1 - y0,
              //C区域
              xc = glassW * 1 - x0, yc = glassH * 1 - y0,
              //在G区域 计算孔的位置
                  //D区域
  //只有X标注没有Y标注 
  xd=x0,yd=glassH * 1/2,
  //E区域
  //只有X标注没有Y标注 
  xe=glassW * 1/2,ye=glassH * 1/2,
  //F区域
  //只有X标注没有Y标注 
  xf=glassW * 1-x0,yf=glassH * 1/2,
              xg = x0, yg = y0,
              //在H区域 计算孔的位置
              //只标注Y
              xh = glassW * 1 / 2, yh = y0,
              //在I区域 计算孔的位置
              xi = glassW * 1 - x0, yi = y0;
        var OffsetParam = {};
  } else if (frame == "IsoscelesTrapezoid") {
  } else if (frame == "RightAngledTrapezoid") {
  } else if (frame == "OtherTrapezoidsA") {
  } else if (frame == "OtherTrapezoidsB") {
  } else if (frame == "ParallelogramA") {
  } else if (frame == "ParallelogramB") {
  }
  // 坐标参数
  var paramCoordinate = { x0,dd,h0,w0,d,w,h,r,cutLine,cutFilletRadius,xa, ya, xb, yb, xd, yd, xf, yf, xc, yc, xg, yg, xh, yh, xi, yi,glassW,glassH};
  const allKeys = Object.getOwnPropertyNames(JSON.parse(JSON.stringify(model.plate.models)));
  var areaPoint = "";
  console.log("//角7、地弹簧3 ------", allKeys)
  if (allKeys[0] == frame) {
        allKeys.shift();//去掉数组第一个元素
  }
  console.log("//角7、地弹簧3 位置去掉数组第一个元素------", allKeys)
  switch (area) {
        case "1": areaPoint = "A"; break;
        case "2": areaPoint = "B"; break;
        case "3": areaPoint = "C"; break;
        case "4": areaPoint = "D"; break;
        case "6": areaPoint = "F"; break;
        case "7": areaPoint = "G"; break;
        case "8": areaPoint = "H"; break;
        case "9": areaPoint = "I"; break;
  }
  /**
  * 画图
  * 
  */
  var ObjName = "myStressHoleGap" + areaPoint;
  var ObjNameMmyStressHoleGap = "myStressHoleGap" + areaPoint + "Mark";//角标记
  ObjName = creatmyStressHoleGap(areaPoint, paramCoordinate);//图形
  console.log("ObjName===|||||||||", ObjName);
  ObjNameMmyStressHoleGap = creatmyStressHoleGapMark(outParam, areaPoint, paramCoordinate, inputParam, fixedParam, OffsetParam, zoom);//图形
  console.log("ObjNameMmyStressHoleGap===|||||||||角标注", ObjNameMmyStressHoleGap);
  console.log("cutPlate.models====************", cutPlate.models),
        console.log("plate.models====**************", plate.models),
        console.log("markers.models====*************", markers.models),
     // myShgGapAMakerH,myShgGapAMakerX,myShgGapAMakerD,myShgGapAMakerW
        cutPlate.models["TypeGapes_myStressHoleGap" + areaPoint + myHolesNum] = ObjName[1];
  plate.models["TypeGapes_myStressHoleGap" + areaPoint + myHolesNum] = ObjName[1];
  markers.models["TypeGapes_myStressHoleGap" + areaPoint + myHolesNum] = ObjName[1];
  markers.models["TypeGapes_myStressHoleGapH" + areaPoint + myHolesNum + "Mark"] = ObjNameMmyStressHoleGap[0];
  markers.models["TypeGapes_myStressHoleGapX" + areaPoint + myHolesNum + "Mark"] = ObjNameMmyStressHoleGap[1];
  markers.models["TypeGapes_myStressHoleGapD" + areaPoint + myHolesNum + "Mark"] = ObjNameMmyStressHoleGap[2];
  markers.models["TypeGapes_myStressHoleGapW" + areaPoint + myHolesNum + "Mark"] = ObjNameMmyStressHoleGap[3];

myHolesNum++;
return{plate,cutPlate, markers,myHolesNum}
};


export default StressHoleGap;